import { Component, OnInit, ViewChild } from '@angular/core';import { loadMessages } from 'devextreme/localization';
import { TranslateService } from '@ngx-translate/core';import { Router } from '@angular/router';
import { DxDataGridComponent } from 'devextreme-angular';
import { ObjectsService } from 'src/app/shared/services/hr/objects.service';
import { genericCustomStoreService } from 'src/app/shared/services/genericCustomStore.service';
import { publicSettingService } from 'src/app/shared/services/hr/publicSetting';

@Component({
  selector: 'app-permission-header-work-system',
  templateUrl: './permission-header-work-system.component.html',
  styleUrls: ['./permission-header-work-system.component.scss']
})
export class PermissionHeaderWorkSystemComponent implements OnInit {
  button={}
  customDataSource: any;
  LOCALIZATION_LOCAL_STORAGE_KEY = "Language";
  currentLang:any;
@ViewChild(DxDataGridComponent) grid:DxDataGridComponent
constructor(public gt:genericCustomStoreService,
  public Objects:ObjectsService,public _publicSettingService:publicSettingService,public router:Router) {
  this._publicSettingService.submit("PermissionHeaderWorkSystem")
  this.customDataSource =_publicSettingService.customDataSource;  
  this.button=Objects.button;
  this.currentLang = localStorage.getItem(
    this.LOCALIZATION_LOCAL_STORAGE_KEY
  );

}
ngOnInit(): void {
  this._publicSettingService.$PERMISSION_ReFRESH.subscribe(res=>{
  if(res){
  this._publicSettingService.submit("PermissionHeaderWorkSystem")
  this.customDataSource =this._publicSettingService.customDataSource; 
  this.grid.instance.refresh()

    }
  })
}

PermissionHeaderWorkSystem(e:any){    
  debugger;        
  this.router.navigate(['hr/add-edit-PermissionHeaderWorkSystem']) 
  this._publicSettingService.$PERMISSION_ID.next(e.key?e.key:0)
}
addrowfun(name:string){
  return this.gt.addrow(name)
}
}
